import { SaleCondition } from "./condicionVenta.models";
import { Talonario } from "./talonario.models";
import { Voucher } from "./voucher.models";

export class Header {
  id?: number;
  receiptBookId: number;
  number: number | null;
  dateFrom: string | null;
  dateTo: string | null;
  expirationDate: string | null;
  activityStartDate?: string | null;
  issuerCuit?: string | null;
  address?: string | null;
  socialReason?: string | null;
  receptorCuit: string | null;
  saleConditionId?: number; // Condición de venta asociada - opcional
  grossIncome?: string | null;
  priceListId?: number;
  createdAt?: Date | null;
  updatedAt?: Date | null;
  deletedAt?: Date | null;
  // Relaciones
  saleCondition?: SaleCondition; // Relación con la condición de venta
  receiptBook?: Talonario;
  vouchers?: Voucher[];
  salesPointsId?: number; // Opcional
}
